import { useMemo } from "react"
import { IAssetViewContextValue } from "./types"

/**
 * Custom hook to extract AssetView-specific analytics properties with memoization.
 * Only recomputes when primitive analytics values change.
 *
 * Note: Dashboard properties (modelId, instrumentId, etc.) are inherited automatically
 * through provider nesting - they should NOT be extracted here.
 *
 * @param assetViewContext - The asset view context value
 * @returns Memoized asset view analytics properties
 */
export function useExtractAssetViewContextProperties(
  assetViewContext: IAssetViewContextValue,
) {
  const view = assetViewContext.view
  const groupByLabel = assetViewContext.groupBy?.label
  const groupById = assetViewContext.groupBy?.id
  const showNotHeld = assetViewContext.showNotHeld
  const showMetricsSelector = assetViewContext.showMetricsSelector
  const navigationPath = assetViewContext.selectedTableLevels?.join("-")
  const navigationDepth = assetViewContext.selectedTableLevels?.length

  // Return memoized object depending only on primitive values
  return useMemo(
    () => ({
      view,
      groupBy: groupByLabel || groupById,
      showNotHeld,
      showMetricsSelector,
      navigationPath,
      navigationDepth,
    }),
    [view, groupByLabel, groupById, showNotHeld, showMetricsSelector, navigationPath, navigationDepth],
  )
}
